import createVueApp from '@/common/create_app'

async function mount(props) {
  const { default: GeogridComparison } = await import('@/vue_widgets/stats/gmb/geogrid_comparison/index.vue')
  createVueApp(GeogridComparison, { props })
}

Styxie.Initializers.StatsGmbGeogridConfigs = {
  compare: mount
}

Styxie.Initializers.StatsGmbPublicSearchTermsComparison = {
  show: mount
}
